module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp-1942976c81e4d5d9aa8ad9f3786fa684.jpg";